import {useCallback, useEffect} from 'react';
import {isNil} from 'lodash-es';
import {Func} from '../types/Func';

interface KeyCommands {
  ctrlC?: Func;
  ctrlV?: Func;
  ctrlZ?: Func;
  delete?: Func;
  escape?: Func;
  enter?: Func;
  ctrlUp?: Func;
}

export function useKeyCommands(commands: KeyCommands, target: EventTarget = window) {
  const processCommandKeys = useCallback(
    (event: Event) => {
      const keyboardEvent: KeyboardEvent = event as KeyboardEvent;

      if (!keyboardEvent.ctrlKey && keyboardEvent.key === 'Delete') {
        if (!isNil(commands.delete)) {
          commands.delete();
        }
      }

      if (!keyboardEvent.ctrlKey && keyboardEvent.key === 'Escape') {
        if (!isNil(commands.escape)) {
          commands.escape();
        }
      }

      if (!keyboardEvent.ctrlKey && keyboardEvent.key === 'Enter') {
        if (!isNil(commands.enter)) {
          commands.enter();
        }
      }

      if (keyboardEvent.ctrlKey && keyboardEvent.code === 'KeyC') {
        if (!isNil(commands.ctrlC)) {
          commands.ctrlC();
        }
      }

      if (keyboardEvent.ctrlKey && keyboardEvent.code === 'KeyV') {
        if (!isNil(commands.ctrlV)) {
          commands.ctrlV();
        }
      }

      if (keyboardEvent.ctrlKey && keyboardEvent.code === 'KeyZ') {
        if (!isNil(commands.ctrlZ)) {
          commands.ctrlZ();
        }
      }

      if (keyboardEvent.ctrlKey && keyboardEvent.code === 'ArrowUp') {
        if (!isNil(commands.ctrlZ)) {
          commands.ctrlUp();
        }
      }
    },
    [
      commands.ctrlC,
      commands.ctrlV,
      commands.ctrlZ,
      commands.delete,
      commands.escape,
      commands.enter,
      commands.ctrlUp
    ]
  );

  useEffect(
    () => {
      if (isNil(target)) {
        return undefined;
      }

      target.addEventListener('keydown', processCommandKeys, false);
      return () => {
        if (isNil(target)) {
          return;
        }

        target.removeEventListener('keydown', processCommandKeys, false);
      };
    },
    [target, processCommandKeys]
  );
}
